import Vue from 'vue'
import Router from 'vue-router'
// import Login from '@/views/login/local'//测试
import Login from '@/views/login/index'//线上
import Layout from '@/views/layout/layout'
import HomeMain from '@/views/index/mainIndex'

// 不是必须加载的组件使用懒加载 
const NotFound = () => import('@/page404')

Vue.use(Router)
let defaultRouter = [{
  path: '/',
  redirect: '/index',
  hidden: true,
  children: []
},
{
  path: '/index',
  iconCls: 'fa el-icon-s-home', // 图标样式class
  name: '种苗系统主页',
  alone: true,
  component: Layout,
  children: [{
    name: '主页',
    path: '/index',
    component: HomeMain
  }]
},
{
  path: '/ent/register',
  iconCls: 'fa el-icon-s-management', // 图标样式class
  name: '企业信息登记',
  alone: true,
  component: Layout,
  children: [{
    hidden: true,
    iconCls: 'el-icon-arrow-right',
    path: '/ent/register',
    name: '企业信息登记',
    meta: { keepAlive: true, url: "/GrainEnt/ent_grain.html" },
    component: () => import('@/views/iframe/index.vue')
  }]
},
// {
//   path: '/ent',
//   iconCls: 'fa el-icon-s-management', // 图标样式class
//   name: '使用帮助',
//   alone: true,
//   component: Layout,
//   children: [{
//     hidden: true,
//     name: '企业信息登记',
//     path: '/ent',
//     component: HomeMain
//   }]
// },
{
  path: '/login',
  component: Login,
  name: '',
  hidden: true,
  children: []
},
{
  path: '/404',
  component: NotFound,
  name: '404',
  hidden: true,
  children: []
}
]

import { zcckRouters } from "./zcck"
import { yzdwRouters } from "./yzdw"
import { glzzcRouters } from "./glzzc"

let addRouter = []
addRouter.push(...yzdwRouters)
addRouter.push(...glzzcRouters)
addRouter.push(...zcckRouters)
export default new Router({
  routes: defaultRouter
})
export {
  defaultRouter,
  addRouter
}



// WEBPACK FOOTER //
// ./src/router/index.js